import { safeLocalStorage } from './safeStorage';

export const hasStoredFormEventId = (id) => {
	let formEventIds = safeLocalStorage.getItem('formEventIds', window);
	formEventIds = formEventIds ? JSON.parse(formEventIds) : [];
	return formEventIds.indexOf(id) > -1;
};

export const storeFormEventId = (id) => {
	let formEventIds = safeLocalStorage.getItem('formEventIds');
	formEventIds = formEventIds ? JSON.parse(formEventIds) : [];
	formEventIds.push(id);
	formEventIds = JSON.stringify(formEventIds);
	safeLocalStorage.setItem('formEventIds', formEventIds, window);
};
